import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { NotificationRow } from '@models/notification';
import dayjs from 'dayjs';

import useNotificationClick from './hooks/useNotificationClick';

interface Props {
    notification: NotificationRow
}

function NotificationItem({ notification }:Props) {
    const {
        readAt, title, createdAt, body,
    } = notification;
    const onClick = useNotificationClick(notification);
    const isUnread = !readAt;
    return (<Item fullWidth
        onClick={onClick}
        spacing={2} >
        <Row fullWidth
            justify='space-between'
            align='center'
            spacing={2} >
            <TitleRow spacing={1}>
                <Text color={colors.textSecondary} ellipsis size='body-short' >
                    {title}
                </Text>
                {isUnread && (<UnreadDot aria-label='unread'/>)}
            </TitleRow>
            <DateText color={colors.textSecondary} size='body-short' >
                {createdAt ? dayjs(createdAt).format('YYYY.MM.DD HH:mm') : '-'}
            </DateText>
        </Row>
        <ContentText size='title'>{body}</ContentText>
    </Item>);
}

const Item = styled(Column)`
    background-color: var(--color-white);
    border-bottom: 1px solid var(--color-border-default);
    padding: var(--spacing-6) var(--spacing-4);
`;

const TitleRow = styled(Row)`
    min-width: 0;
`;

const UnreadDot = styled.span`
    background-color: var(--color-text-error);
    border-radius: var(--radius-full);
    flex-shrink: 0;
    height: 4px;
    width: 4px;
`;

const DateText = styled(Text)`
    flex-shrink: 0;
    white-space: nowrap;
`;

const ContentText = styled(Text)`
    white-space: pre-wrap;
    word-break: break-word;
`;

export default NotificationItem;
